<template>
  <div>
    <div :class="`${node.type == 'group' ? 'node-hover' : ''}`">
      <div
          :style="{'margin-left': 25 * depth + 'px'}"
      >
        <div class="d-flex justify-content-between">
          <div  class="node" @click="expanded = !expanded">
            <span v-if="hasChildren">{{ expanded ? '&#9660' : '&#9658'}}</span>
            <span v-if="node.type == 'group'">{{ node.name }}</span>
          </div>
        </div>
        <div
            class="d-flex align-items-center bg-black-light justify-content-between rounded-3 p-2 mb-2 border"
            v-if="node.type === 'endpoint'"
        >
          <div class="d-flex flex-column">
            <span class="fw-bold text-dark">{{ node.name }}</span>
            <small class="text-dark">Weight: {{ node.weight }}%</small>
          </div>

          <div v-if="performanceAppraisal && performanceAppraisal.can_evaluate" class="d-flex align-items-center gap-3" style="min-width: 300px;">
            <v-select
                v-model="node.performance_apprisal_note_master"
                :options="performanceAppraisalNote"
                label="name"
                placeholder="Select Score"
                class="flex-grow-1"
            />
            <span class="fw-semibold">Score: {{ node.score ?? 0 }}</span>
          </div>
        </div>

      </div>
    </div>
    <hr class="mb-1 mt-0" v-if="type == 'group'">
    <template v-if="expanded">
      <PerformanceComponentForm
          v-for="item in node.active_child"
          :key="item.name"
          :parent="node"
          :depth="depth + 1"
          :node="item"
          :performanceAppraisalNote="performanceAppraisalNote"
          :performanceAppraisal="performanceAppraisal"
      />
    </template>
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";

const props = defineProps({
  node: {
    type: Object,
    required: true
  },
  depth: {
    type: Number,
    default: 0
  },
  parent: {
    default: () => []
  },
  performanceAppraisalNote:{
    type: Array,
    default: () => []
  },
  performanceAppraisal:{
    type: Object,
    default: () => {}
  }
})

watch(() => props.node.performance_apprisal_note_master, (newVal, oldVal) => {
   if (newVal){
     props.node.score = newVal.score;
   }
});

const expanded = ref(true)

const hasChildren = computed(() => {
  return props.node.active_child.length
})

const type = computed(() => {
  return props.node.type
})

</script>

<style scoped>
.bg-black-light {
  background: #00000024;
}
.rounded-8 {
  border-radius: 8px;
}
.node {
  cursor: pointer;
}
.node-hover {
  padding: 10px 2px;
}
.node-hover:hover {
  background: #fffeec;
}
.cursor-initial {
  cursor: initial;
}
.cursor-pointer {
  cursor: pointer;
}
.w-30 {
  width: 30px;
}
.w-20 {
  width: 20px;
}
.z-999 {
  z-index: 999;
}
.w-44 {
  width: 44px;
}
</style>
